import React from "react";
import { react } from "mobx";
import { inject, observer } from "mobx-react";
import {Button, Form, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {Component} from "react/lib/ReactBaseClasses";
import store from "../../../stores";
import loading from '../../../assets/images/ajax-loader.gif';

@inject("store")
@observer
class ModalForm extends Component {

    constructor(props) {
        super(props);
        this.modalStore = this.props.store.modalStore;
        this.formStore = this.props.store.formStore;
        this.validacaoStore = this.props.store.validacaoStore;
    }

    componentWillMount() {
        this.modalStore.setSubmitted(false);
        this.modalStore.setSubmitMensagemErro("");
        this.formStore.setSubmitted(false);
        this.formStore.setSubmitMensagemErro("");
        this.modalStore.setLoading(false);
    }

    render() {
        return (

            <Modal className={this.props.className} backdrop={'static'} keyboard={!this.modalStore.loading} isOpen={true} toggle={() => {
                this.modalStore.toggleModal();
                this.validacaoStore.desabilitarValidacao = false;
            }}>
                {this.props.closeButton ?
                    <ModalHeader toggle={() => {
                        this.modalStore.toggleModal();
                        this.validacaoStore.desabilitarValidacao = false;}}>{this.props.cabecalho}</ModalHeader>
                    :
                    <ModalHeader >{this.props.cabecalho}</ModalHeader>
                }

                <ModalBody>
                    <Form>
                    {this.props.corpo}
                    </Form>
                </ModalBody>
                {this.props.botoes &&
                    <ModalFooter>
                        <p>{ this.modalStore.submitMensagemErro }</p>
                        {this.modalStore.loading ? <img src={loading} alt="loading" className="loading"/> : ""}
                        { this.props.botoes }
                    </ModalFooter>
                }
            </Modal> );
    }
};

export {ModalForm}